// Полоска-анонс конференции: закрытие крестиком.
//
// Показ полоски здесь не живёт — он синхронный и сделан инлайн-скриптом партиала
// (иначе закрытая полоска мигала бы на каждой загрузке, бандл подключён с defer).
export function initConferenceBar() {
  const bar = document.getElementById('conferenceBar');
  if (!bar) return;

  // Обработчику остаётся запомнить день закрытия: на следующий день записанная дата
  // с сегодняшней не совпадёт, и полоска вернётся сама.
  bar.querySelector('[data-conference-bar-close]')?.addEventListener('click', () => {
    try {
      // Ключ несёт id конференции: новый анонс увидит и тот, кто закрыл предыдущий.
      localStorage.setItem(bar.dataset.dismissKey, bar.dataset.today);
    } catch (e) {
      // Хранилище недоступно (приватный режим) — закрываем только на этой странице.
    }

    bar.hidden = true;
    document.body.classList.remove('conference-bar-visible');
  });
}
